import React from 'react'
import Head from 'next/head'
import AboutMartinPage from 'pages/website/LandingPage/EntrepreneurSeminar/AboutMartinPage'
import useJumpstartIntake from 'pages/website/LandingPage/EntrepreneurSeminar/useJumpstartIntake'
import CommonHead from '../_head'

const AboutMartin = () => {
  const onIntakeSubmit = useJumpstartIntake('jumpstart')

  return (
    <>
      <Head>
        <title>About Martin Warner | Entrepreneur Seminar</title>
        <CommonHead description="Martin Warner is one of Britain's leading entrepreneurs and a global thought leader on entrepreneurship. Founder and CEO of warpSpeed, founder of Flix Premiere and Entrepreneur Seminar, and co-founder of botObjects, sold for $50 million in 17 months." />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap"
        />
      </Head>
      <AboutMartinPage onIntakeSubmit={onIntakeSubmit} />
    </>
  )
}

export const getServerSideProps = () => ({ props: { topNavActive: false, footerActive: false } })

export default AboutMartin
